import React from 'react';

const SearchHeading = ({ query }: { query: string }) => {
  if (!query) {
    return <>Search the wiki</>;
  }
  return (
    <>
      Results for <span className="text-blue-600 dark:text-blue-300">{`“${query}”`}</span>
    </>
  );
};

export default SearchHeading;
